import type { Me } from "../../shared/types";
import { logout } from "../auth";
import { navigate, type Route } from "../router";

export function AppBar({ me, route }: { me: Me; route: Route["name"] }) {
  const tab = (name: string, label: string, to: string, active: boolean) => (
    <a key={name} href={to} className={`nav${active ? " on" : ""}`} onClick={(e) => { e.preventDefault(); navigate(to); }}>{label}</a>
  );
  return (
    <header className="appbar">
      <div className="appbar-in">
        <img src="/vetproof-logo.png" alt="Vetproof — one scan, full story" onClick={() => navigate("/")} />
        <span className="release">Release 1.0</span>
        {me.role === "vet" && (
          <nav className="navs">
            {tab("patients", "Patients", "/", route === "list" || route === "pet" || route === "emergency")}
            {tab("scan", "Scan", "/scan", route === "scan")}
          </nav>
        )}
        <span className="sp" />
        <div className="who">
          <b>
            {me.displayName}
            <span className="role-pill">{me.role === "vet" ? "Clinic" : "Owner"}</span>
          </b>
          {me.vet ? me.vet.clinicName : me.email}
        </div>
        <button className="btn ghost sm" onClick={logout}>Sign out</button>
      </div>
    </header>
  );
}
